import { render, staticRenderFns } from "./DashboardCardTwo.vue?vue&type=template&id=25cab2fc&scoped=true&"
import script from "./DashboardCardTwo.vue?vue&type=script&lang=js&"
export * from "./DashboardCardTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cab2fc",
  null
  
)

export default component.exports